import ImgOne from "../assets/1.png";
import ImgTwo from "../assets/2.png";
import ImgThree from "../assets/3.png";
import ImgFour from "../assets/4.png";
import ImgFive from "../assets/5.png";
import ImgSix from "../assets/6.png";
import ImgSeven from "../assets/7.png";

/**
 * Service catalogue.
 *
 * Content is structured rather than pre-rendered JSX so the card grid and the
 * detail modal can present the same source material with consistent styling.
 *
 *   body     — array of paragraphs
 *   sections — { heading, body?, items?, note? } blocks rendered in order
 *   video    — optional YouTube embed URL shown at the top of the modal
 */
const services = [
  {
    id: 1,
    num: "01",
    image: ImgOne,
    title: "Milling & Underreaming",
    tagline: "Downhole removal",
    description:
      "Milling services are provided through Anfield’s team of experienced fishing tool supervisors and a comprehensive line of milling tools.",
    body: ["We offer all common types of mills including:"],
    sections: [
      {
        heading: "Mill types",
        items: [
          "Junk Mills",
          "Pilot Mills",
          "Taper Mills",
          "Section mills for casing exits",
        ],
      },
      {
        heading: "Underreamers",
        body: [
          "Underreaming services are available to enlarge the well-bore using field tested retractable arm tools that are fitted with milled tooth cutters. Tool body and finished hole sizes range from 4-3/4″ to 40″.",
        ],
      },
    ],
    specs: [{ label: "Hole size range", value: "4-3/4″ – 40″" }],
  },
  {
    id: 2,
    num: "02",
    image: ImgTwo,
    title: "Casing Exit Systems",
    tagline: "Easy-Trak™ departure",
    description:
      "Anfield Services Ltd. now provides the ITS Easy-Trak™ Casing Departure System, a unique whipstock/multi-mill combination tool used for window milling and sidetracking operations.",
    body: [
      "Designed and manufactured to provide a reliable choice to casing exit operations, the Easy-Trak™ Casing Departure System is a one-trip system that facilitates the quick cutting of a uniform and usable window without the need to change the components of the bottom-hole assembly.",
      "Available in a wide range of standard and custom-made sizes using whipstocks that can be either retrieved or permanently set, the Easy-Trak™ Casing Departure System offers the flexibility to meet a variety of applications.",
      "A trouble-free job with minimal downtime is every operator’s goal. Our Easy-Trak™ Casing Departure Systems provide the reliability to ensure a smooth, successful and efficient outcome to all window milling projects.",
    ],
    sections: [],
    specs: [{ label: "System", value: "One-trip" }],
  },
  {
    id: 3,
    num: "03",
    image: ImgThree,
    title: "Chart Torquing Services",
    tagline: "Make-up / break-out",
    description:
      "Mobile/In House Chart Torquing Services available. Hydraulic Make-Up/Break-Out unit for all tubulars.",
    body: [],
    sections: [
      {
        heading: "Ranges and dimensions",
        items: [
          "O.D. Range – Base Package: 7″ to 11″",
          "Torque Range – Make-Up: 100,000 ft-lbs",
          "Torque Range – Break-Out: 150,000 ft-lbs",
          "Arm Spacing Adjustment: 6ft or more",
          "Dimensions: 97″W x 90″H x 112″D",
          "Weight: 5000 lbs",
        ],
      },
      {
        heading: "All of our machines feature the following",
        items: [
          "Safe and Easy to Operate",
          "Compact and Portable",
          "Instantly Converts between Make-Up and Break-Out Operation",
          "Built in Backup Arm",
          "Accurate Torque Control",
          "Easy Torque Adjustments",
          "Operates in Horizontal or Vertical Position",
        ],
      },
      {
        heading: "Multiple power pack options",
        body: [
          "Diesel, Electric, Gasoline, Pneumatic/Air, Rig’s hydraulic system",
        ],
      },
      {
        heading: "Optional accessories",
        body: [
          "TorqueShark™ Torque Recording System, Reducer Package, Bit Breaker, Additional Links, Jaws for larger O.Ds, DPT – Drill pipe package.",
        ],
      },
    ],
    specs: [
      { label: "Make-up", value: "100,000 ft-lbs" },
      { label: "Break-out", value: "150,000 ft-lbs" },
    ],
  },
  {
    id: 4,
    num: "04",
    image: ImgFour,
    title: "Certified Equipment Racks",
    tagline: "Load tested & MPI",
    description:
      "Engineered/Certified Equipment Racks are available at Anfield Services Ltd. All racks are custom built, load tested and MPI inspected.",
    body: [
      "Anfield Services Ltd. offers custom-engineered and certified equipment racks designed to meet the specific needs of your operation. Our equipment racks are built to the highest quality standards, ensuring safe and efficient storage and transportation of your valuable tools and equipment.",
      "Each equipment rack is meticulously crafted with robust materials and goes through rigorous load testing to guarantee its durability and performance under various load conditions. In addition, our equipment racks undergo Magnetic Particle Inspection (MPI) to identify and address any potential surface and subsurface flaws, ensuring maximum safety and reliability.",
    ],
    sections: [],
    specs: [{ label: "Inspection", value: "MPI certified" }],
  },
  {
    id: 5,
    num: "05",
    image: ImgFive,
    title: "Fabrication Services",
    tagline: "ASL Fabricators",
    description:
      "ASL Fabricators at Anfield Services Ltd. provides specialized, high-quality service",
    body: [],
    sections: [
      {
        heading: "Capabilities",
        items: [
          "Redress of Oilfield Equipment",
          "Application of Hard Metals",
          "General Fabrication",
          "Certified Equipment Racks for Warehouse Storage",
          "Tank Building and Tank Stands",
          "Skid Manufacture",
        ],
      },
    ],
    specs: [{ label: "Scope", value: "In-house shop" }],
  },
  {
    id: 6,
    num: "06",
    image: ImgSix,
    title: "Fishing Tools",
    tagline: "Recovery & retrieval",
    description:
      "Our fishing capabilities extend from wireline and 1″ tubing to 42″ casing, open and cased hole, external and internal catch fishing.",
    body: [
      "Anfield Services Ltd. provides state-of-the-art equipment and highly qualified personnel trained in recovery of equipment lost or stuck downhole. Our extensive knowledge and experience in fishing safely and efficiently make us the best choice for getting your drilling and completion programs back on track with the least impact to your risk and NPT. From stuck-pipe and BHA retrieval services to simple junk removal, if it’s been stuck or lost in a well, we’ve probably already removed it successfully. Our fishing capabilities extend from wireline and 1″ tubing to 42″ casing, open and cased hole, external and internal catch fishing.",
    ],
    sections: [
      {
        heading: "Our line of tools include",
        items: [
          "Overshots",
          "Bumpersubs, Jars and Accelerators",
          "Spears",
          "Washpipe",
          "Reverse Circulating Junk Baskets (RCJBs)",
          "ADT junk retrievers",
          "Other Specialty tools",
        ],
      },
    ],
    specs: [{ label: "Catch range", value: "1″ tubing – 42″ casing" }],
  },
  {
    id: 7,
    num: "07",
    image: ImgSeven,
    title: "PBL Multiple Activation Bypass System",
    tagline: "DSI multi-cycle",
    description:
      "DSI PBL Multiple Activation Bypass System is the leading multi-cycle circulating tool in the Oil & Gas industry today.",
    video: "https://www.youtube.com/embed/I3pA89ipiqs",
    body: [
      "DSI PBL Multiple Activation Bypass System is the leading multi-cycle circulating tool in the Oil & Gas industry today. Simple and robust, PBL Tool consists of a “Main Body” which houses all the major components required to enable activation, deactivation and proper functioning of the tool. A “Catcher Sub” located below the Main Body contains the “Catcher Cage” enabling the spent balls / darts to be captured within it.",
    ],
    sections: [],
    specs: [{ label: "Cycles", value: "Multi-activation" }],
  },
];

export default services;
